module.exports = ".scrollarea {\r\n  height: auto;\r\n  overflow: scroll;\r\n  border:thin solid #ccc;\r\n  background-color:#fff;\r\n  border-radius: 4px;\r\n  }\r\n  .selectionarea {\r\n      width:35rem;\r\n      padding:5px;\r\n      height: 130px;\r\n  }\r\n  .selectedarea {\r\n      width:35rem;\r\n      padding:5px;\r\n      height: 260px;\r\n  }\r\n  .mailviewarea {\r\n      padding:5px;\r\n      height: 500px;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/a0108-person/a-output-modal.component.css
// module id = ./src/app/a0108-person/a-output-modal.component.css
// module chunks = main